const e = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
    <path fill="currentColor" fill-rule="evenodd"
        d="M0 3.5C0 1.567 1.567 0 3.5 0H10.5C12.433 0 14 1.567 14 3.5V10.5C14 12.433 12.433 14 10.5 14H3.5C1.567 14 0 12.433 0 10.5V3.5ZM7 3.25C7.41421 3.25 7.75 3.58579 7.75 4V6.25H10C10.4142 6.25 10.75 6.58579 10.75 7C10.75 7.41421 10.4142 7.75 10 7.75H7.75V10C7.75 10.4142 7.41421 10.75 7 10.75C6.58579 10.75 6.25 10.4142 6.25 10V7.75H4C3.58579 7.75 3.25 7.41421 3.25 7C3.25 6.58579 3.58579 6.25 4 6.25H6.25V4C6.25 3.58579 6.58579 3.25 7 3.25Z"
        clip-rule="evenodd"></path>
</svg>`;
export {
  e as default
};
